import React, { useState, useEffect } from "react";
import {
  Container,
  Navbar,
  Nav,
  NavDropdown,
  Modal,
  Form,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import "./Header.css";
import { LinkContainer } from "react-router-bootstrap";
import logo from "./logo.png";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "./actions/user.actions";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Header() {
  const navigate = useNavigate();

  // Fetch existing rates on mount
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await axios.get("/api/rate/1");
        setcs(response.data.cs || "");
        setmc(response.data.mc || "");
        setSGold18(response.data.sgold18 || "");
        setSGold22(response.data.sgold22 || "");
      } catch (error) {
        console.error("Failed to fetch rates:", error);
      }
    };
    fetchRates();
  }, []);

  const handleRateSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put("/api/rate/1/", {
        cs: cs,
        mc: mc,
        sgold18: sgold18,
        sgold22: sgold22,
      });
      setShowModal(false);
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert("Error updating rates.");
    }
  };

  const [cs, setcs] = useState("");
  const [mc, setmc] = useState("");
  const [sgold18, setSGold18] = useState("");
  const [sgold22, setSGold22] = useState("");
  const [showModal, setShowModal] = useState(false);

  const signoutSession = () => {
    sessionStorage.removeItem("user");
    localStorage.removeItem("user");
    dispatch(userActions.login({}));
    navigate("/");
  };

  const dispatch = useDispatch();
  const user = useSelector((state) => state.authentication.user);

  let initialsString = ""; // Initialize initialsString outside the condition

  if (user && user.full_name) {
    const words = user.full_name.split(" ");
    const initials = words.map((word) => word.charAt(0).toUpperCase());
    initialsString = initials.join("");
  }

  return (
    <div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Sale Rates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleRateSubmit}>
            <h6 style={{ color: "#082372" }}>Sale Rates</h6>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="cs">
                  <Form.Label style={{ color: "#000", marginTop: "5px" }}>
                    Color Stone
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={cs}
                    onChange={(e) => setcs(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="mc">
                  <Form.Label style={{ color: "#000", marginTop: "5px" }}>
                    Making Charges
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={mc}
                    onChange={(e) => setmc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="sgold18">
                  <Form.Label style={{ color: "#000", marginTop: "5px" }}>
                    Gold 18 CT
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={sgold18}
                    onChange={(e) => setSGold18(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="sgold22">
                  <Form.Label style={{ color: "#000", marginTop: "5px" }}>
                    Gold 22 CT
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={sgold22}
                    onChange={(e) => setSGold22(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button
                variant="secondary"
                onClick={() => setShowModal(false)}
                className="me-2"
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Update
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Navbar
        sticky="top"
        collapseOnSelect
        className="navbarBg"
        expand="lg"
        variant="dark"
      >
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
              <img
                alt="Jsgif"
                src={logo}
                className="d-inline-block align-top brandImage"
              />
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              {(() => {
                if (
                  typeof user !== "undefined" &&
                  typeof user.email !== "undefined"
                ) {
                  return (
                    <>
                      <LinkContainer to="/products">
                        <Nav.Link>Product List</Nav.Link>
                      </LinkContainer>
                      <LinkContainer to="/create-product">
                        <Nav.Link>Add Product</Nav.Link>
                      </LinkContainer>
                      <Nav.Link onClick={() => setShowModal(true)}>
                        Edit Rates
                      </Nav.Link>
                      <LinkContainer to="/">
                        <Nav.Link onClick={signoutSession}>Sign Out</Nav.Link>
                      </LinkContainer>
                    </>
                  );
                } else
                  return (
                    <LinkContainer to="/login">
                      <Nav.Link>Login</Nav.Link>
                    </LinkContainer>
                  );
              })()}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;
